import {Directive, EventEmitter, HostBinding, HostListener, Output} from '@angular/core';

@Directive({
  selector: '[appImageDragNDrop]',
  standalone: true
})
export class ImageDragNDropDirective {
  @Output() private filesChangeEmitter: EventEmitter<File[]> = new EventEmitter();
  @HostBinding('style.background') background = '#eee';
  @HostBinding('style.border') borderStyle = '2px dashed';
  @HostBinding('style.border-color') borderColor = '#696D7D';
  @HostBinding('style.border-radius') borderRadius = '5px';

  constructor() {
  }

  @HostListener('dragover', ['$event'])
  public onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = 'lightgray';
    this.borderColor = 'cadetblue';
    this.borderStyle = '3px solid';
  }

  @HostListener('dragleave', ['$event'])
  public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#eee';
    this.borderColor = '#696D7D';
    this.borderStyle = '2px dashed';
  }

  @HostListener('drop', ['$event'])
  public onDrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#eee';
    this.borderColor = '#696D7D';
    this.borderStyle = '2px dashed';
    let valid_files: Array<File> = evt.dataTransfer.files;
    this.filesChangeEmitter.emit(valid_files);
  }

}
